import { useTranslation } from 'react-i18next'

import { wwtPerformanceLog } from '@wwt/core/admin'

interface GuestInformationSpecialWishesProps {
	comment: string
}

/**
 * Show user comment
 *
 * @author Ivan Shchedrovskyi
 */
export const GuestInformationSpecialWishes = ({
	comment
}: GuestInformationSpecialWishesProps) => {
	wwtPerformanceLog('GuestInformationSpecialWishes')

	const { t } = useTranslation('room-page', {
		keyPrefix: 'reservationTab.specialWishes'
	})

	return (
		<article>
			<h2 className="ts-headline-4 mb-4">{t('title')}</h2>
			<div>{comment}</div>
		</article>
	)
}
